import axiosInstance from '../common/axios';
const backendUrl = process.env.REACT_APP_BACKEND_URL;

// admin referral
export async function getfulFillmentStatus() {
  return axiosInstance.get(`${backendUrl}/api/lookup-values/type/FULFILLMENT_STATUS`);
}

// admin referral
export async function saveFulFillment(data) {
  return axiosInstance.post(`${backendUrl}/api/fulfillment-orders`, data);
}


// admin referral
export async function updateFulFillment(fulfillmentOrderId, data) {
  return axiosInstance.put(`${backendUrl}/api/fulfillment-orders/${fulfillmentOrderId}`, data);
}

export async function updateFulFillmentStatusAndWarehouse(fulfillmentOrderId,warehouseId) {
  return axiosInstance.put(`${backendUrl}/api/fulfillment-orders/${fulfillmentOrderId}/warehouse/${warehouseId}`);
}

// admin referral
export async function updateFulFillmentStatus(fulfillmentOrderId, data) {
    
   // alert(data);
  return axiosInstance.put(`${backendUrl}/api/fulfillment-orders/${fulfillmentOrderId}/status/${data}`);
}


// user referral
export async function getFulFillments() {
  return axiosInstance.get(`${backendUrl}/api/fulfillment-orders`);
}

export async function getSupplierFulFillments(warehouseIds, page,pageSize) {
  return axiosInstance.get(`${backendUrl}/api/fulfillment-orders/by-warehouses`, 
                           {
                params: {
                    page: page,
                    size: pageSize,
                    warehouseIds: warehouseIds || "", // Send the filter value to the backend
                    // You can also add sort: 'columnName,desc' if needed
                }
  });//?warehouseIds=${warehouseIds, page}`);
}

export async function getOrderDetailsFulFillments(fulfillmentOrderId) {

  
return  axiosInstance.get(`${backendUrl}/api/fulfillment-orders/fulfillment/${fulfillmentOrderId}`);
}

